import { render } from "./WebWhatsapp.vue?vue&type=template&id=f5e71302&scoped=true"
import script from "./WebWhatsapp.vue?vue&type=script&lang=js"
export * from "./WebWhatsapp.vue?vue&type=script&lang=js"

import "./WebWhatsapp.vue?vue&type=style&index=0&id=f5e71302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e71302"]])

export default __exports__